import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const DropDownMenu: React.FC<{
  button: any;
  className: string;
  children: React.ReactNode;
}> = ({ button, children, className = '' }) => {
  const [shown, setShown] = useState(false);

  return (
    <div className="relative">
      <span onClick={() => setShown(!shown)} className="cursor-pointer">
        {button}
      </span>
      <AnimatePresence>
        {shown && (
          <motion.div
            initial="hidden"
            key="backdrop"
            animate="visible"
            exit="exit"
            variants={{
              hidden: {
                top: 100,
                opacity: 0,
              },
              visible: {
                top: 'auto',
                opacity: 1,
                transition: {
                  delay: 0,
                  duration: 0.3,
                },
              },
              exit: {
                top: 50,
                opacity: 0,
                transition: {
                  delay: 0,
                  duration: 0.3,
                },
              },
            }}
            className={className}
            onClick={() => {
              setShown(false);
            }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DropDownMenu;
